import React from 'react';
import { useLogin, useNotify } from 'react-admin';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';

const AdminLoginPage = () => {
    const login = useLogin();
    const notify = useNotify();

    const handleSuccess = (credentialResponse) => {
        // The authProvider's login method will receive this object and validate admin role
        login(credentialResponse).catch((error) => {
            // Display specific error message from authProvider
            notify(error || 'Login failed. Please try again.', { type: 'error' });
        });
    };

    const handleError = () => {
        notify('Google authentication failed. Please try again.', { type: 'error' });
    };

    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

    if (!clientId) {
        return (
            <div>
                <h1>Configuration Error</h1>
                <p>Google Client ID is missing. Please set REACT_APP_GOOGLE_CLIENT_ID in your environment.</p>
            </div>
        );
    }

    return (
        <GoogleOAuthProvider clientId={clientId}>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                backgroundColor: '#f5f5f5',
                fontFamily: 'Arial, sans-serif'
            }}>
                <div style={{
                    backgroundColor: 'white',
                    padding: '2rem',
                    borderRadius: '8px',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                    textAlign: 'center',
                    maxWidth: '400px',
                    width: '100%'
                }}>
                    <div style={{ marginBottom: '2rem' }}>
                        <img
                            src={process.env.PUBLIC_URL + '/assets/deepalert_logo.png'}
                            alt="DeepAlert Academy"
                            style={{ maxWidth: '200px', height: 'auto' }}
                        />
                    </div>

                    <GoogleLogin
                        onSuccess={handleSuccess}
                        onError={handleError}
                        size="large"
                        theme="outline"
                        text="signin_with"
                    />
                    <p style={{
                        fontSize: '0.8rem',
                        color: '#999',
                        marginTop: '1rem',
                        lineHeight: '1.4'
                    }}>
                        Only users with administrator privileges can access this interface.
                        Contact support if you need admin access.
                    </p>
                </div>
            </div>
        </GoogleOAuthProvider>
    );
};

export default AdminLoginPage;
